import {
    HostBridgeHandler,
    Command
} from '@hyland/minotaur'
import { HostBridgeEventCallback } from 'phoenix/domain';
import { Action } from 'util/domain';

export class HostBridgeService {
    private hostBridgeHandler : HostBridgeHandler

    public static $inject = [
        '$q',
        '$window'
    ];

    constructor(
        private $q:ng.IQService,
        $window:ng.IWindowService
    ) {
        this.hostBridgeHandler = new HostBridgeHandler($window, $window.document, []);
    }

    public execute(command:Command) {
        let promise = this.hostBridgeHandler.execute$(command).toPromise();
        return this.$q((resolve, reject) => {
            return promise.then(resolve).catch(reject);
        });
    }

    public subscribeToEvent(eventName:string, callback:HostBridgeEventCallback): Action {
        return this.hostBridgeHandler.onEvent$(eventName)
            .subscribe(callback)
            .unsubscribe;
    }

    getCapabilities() {
        return this.hostBridgeHandler.capabilities.capabilitiesMap;
    }
}




// WEBPACK FOOTER //
// ./src/phoenix/services/hostBridgeService.ts